export default [
   {
      step: 1,
      title: 'Levering',
      component: () => import(`./checkout/Delivery`),
      isComplete: () => null,
      isLoading: () => null,
      hasError: () => null
   },
   {
      step: 2,
      title: 'Betaling',
      component: () => import(`./checkout/Payment`),
      isComplete: () => null,
      isLoading: () => null,
      hasError: () => null
   },
   {
      step: 3,
      title: 'Oppsummering',
      component: () => import(`./checkout/Summary`),
      isComplete: () => null,
      isLoading: () => null,
      hasError: () => null
   }
]
